const config = require("../config");

module.exports = {
  smallFileUpload: config.smallFileUploadSize * 1024 * 1024, // 5mb used for candidate photo and resume
  largeFileUpload: config.largeFileUploadSize * 1024 * 1024, // 50mb used for candidate video
};
